import React, { useRef, useState } from 'react'


const ConfirmModal = ({ confirming, handleConfirm, buttonText, cancel, message }) => {
  return <div id="confirm-modal" className={`modal ${ confirming ? 'is-active' : ''}`}>
          <div className="modal-background"></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <h1 className="modal-card-title">
                CONFIRMATION</h1>
              <button onClick={cancel} className="btn-icon-only icon-lg btn-close" aria-label="close">
                <span className="icon icon-close-large"></span><span className="sr-only">Close this
                  dialog</span>
              </button>
            </header>
            <section className="modal-card-body">
              { message }
            </section>
            <footer className="modal-card-foot">
              <div className="is-flex ml-auto">
                <button className="button" onClick={cancel} >Cancel</button>
                <button className="btn-solid" onClick={handleConfirm}>{buttonText}</button>
              </div>
            </footer>
          </div>
        </div>
}

export default ConfirmModal